﻿function initGclid() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var gclid = urlParams.get('gclid');
    if (gclid === null) {
        return;
    }
    else if (gclid === "") {
        return;
    }
    else {
        localStorage.setItem('gclid', gclid);
    }
}
initGclid();